/**
 * max-length-limit directive
 * 限制 ng-model 字符串的长度
 * Created by ph2 on 2016/8/1.
 */

angular.module('RCP').directive('maxLengthLimit', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            var maxLength = Number(attrs.maxLengthLimit);

            ngModelCtrl.$parsers.push(function (text) {
                // console.log('[directive-maxLengthLimit]: source', text, ' len:', text.length);

                if (text.length > maxLength) {
                    var newStr = text.substr(0, maxLength);
                    // $timeout 中调用 `$setViewValue` 更改 viewValue 的原因：
                    // 1.
                    //   `$setViewValue` 会再次遍历运行 `$parsers`
                    //   调用栈 `ctrl.$setViewValue()` => ... => `ctrl.$$parseAndValidate()` => `forEach $parsers` => `该函数`
                    // 2.
                    //   在 ie9 中，<textarea></textarea> 同时设置 `maxlength` 和 `maxLengthLimit` 时，
                    //   因为 `maxlength` 失效，但 angular 仍会读取 `maxlength` 值并检查，若不在 $timeout 中调用，会导致 `maxlength` 检查失败, `$modelValue` 得到 `undefined`
                    $timeout(function () {
                        ngModelCtrl.$setViewValue(newStr);
                        ngModelCtrl.$render();
                    });
                    return newStr;
                }
                return text;
            });
        }
    }
});



// WEBPACK FOOTER //
// ./src/recruit/src/directive/max-length-limit/max-length-limit.js